import { useState } from "react";

import useAuth from "../../../hooks/useAuth";
import styles from "./LocalModeBanner.module.css";

/**
 * Development-only banner.
 *
 * When Firebase isn't configured the app runs on an in-browser backend.
 * That must never be mistaken for the real thing, so we say it out loud
 * on every screen until the developer dismisses it for the session.
 */
const LocalModeBanner = () => {
  const { isLocalMode, backendMode } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (!isLocalMode || dismissed) return null;

  return (
    <div className={styles.LocalModeBanner} role="status">
      <div className="container d-flex align-items-center gap-2">
        <i className="fa-solid fa-flask" aria-hidden="true" />
        <p className={styles.text}>
          <strong>Local development mode.</strong> Firebase isn&rsquo;t
          configured, so sign-in and all saved data live only in this browser.
          Rooms can&rsquo;t be shared with other devices.
          {backendMode.missing.length > 0 && (
            <span className={styles.missing}>
              {" "}
              Missing: {backendMode.missing.join(", ")}.
            </span>
          )}
        </p>
        <button
          type="button"
          className={styles.dismiss}
          onClick={() => setDismissed(true)}
          aria-label="Hide the local development notice"
        >
          <i className="fa-solid fa-xmark" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default LocalModeBanner;
